import { useEffect, useCallback } from "react";

const CountdownTimer = ({ targetDateTime, timeLeft, setTimeLeft, expiredText = 'Time Expired' }) => {

    const calculateTimeLeft = useCallback(() => {
        const difference = +new Date(targetDateTime) - +new Date();
        if (difference > 0) {
            return {
                expired: false,
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60)
            };
        } else {
            return { expired: true, days: 0, hours: 0, minutes: 0, seconds: 0 };
        }
    }, [targetDateTime]); // only changes if targetDateTime changes

    useEffect(() => {
        // Update timer immediately
        setTimeLeft(calculateTimeLeft());

        // update every second
        const id = setInterval(() => setTimeLeft(calculateTimeLeft()), 1000);

        return () => clearInterval(id);
    }, [calculateTimeLeft, setTimeLeft]);

    const timerComponents = Object.keys(timeLeft).map((interval, i) => {
        if (!timeLeft[interval]) return null;
        if (timeLeft.expired) return <span key={i}>{expiredText}</span>;
        return <span key={i}>{timeLeft[interval]} {interval} </span>;
    });

    return Object.keys(timeLeft).length > 0 ? <span>{timerComponents.length ? timerComponents : expiredText}</span> : null;
};

export default CountdownTimer;
